/**
 * Les routes poussées du lot du live : celles qu'il fait passer sur le design system.
 *
 * - `menu` sous le titre `live` : l'écran du live (`StudentLiveScreen`, à la place de
 *   `LiveMainLayout` ; le tuteur garde toujours le sien) ;
 * - `live-end` : la fin de séance de l'élève (`StudentLiveEndScreen`), où mène l'écran du live ;
 * - `end-session-student` : le même écran, pour qui pousse encore la route de l'ancien live ;
 * - `live-satisfaction` : la note en écran, pour qui la pousse encore (`StudentLiveSatisfactionScreen`) ;
 *   l'écran du live du design system note dans sa feuille ;
 * - `live-quiz` : le quiz de fin de séance (`StudentLiveQuizScreen`), poussé à la sortie du live.
 *
 * Toutes vivent en live (`livesInLive`) ; `live-end` et `live-quiz` ont aussi leurs titres hors live :
 * la sortie les pousse avant que la pile bascule. Un écran se charge à son premier rendu
 * (`loadedOnRender`).
 */
import { loadedOnRender } from "../loadedOnRender"
import { livesInLive, type StudentSpaceRouteTable } from "../studentSpaceRouteTypes"

const endScreen = livesInLive(
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    loadedOnRender(() => require("./StudentLiveEndScreen").StudentLiveEndScreen, "StudentLiveEndScreen")
)

export const liveRoutes: StudentSpaceRouteTable<"live"> = {
    menu: livesInLive(
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        loadedOnRender(() => require("./StudentLiveScreen").StudentLiveScreen, "StudentLiveScreen")
    ),
    "live-end": endScreen,
    "end-session-student": endScreen,
    "live-satisfaction": livesInLive(
        loadedOnRender(
            // eslint-disable-next-line @typescript-eslint/no-require-imports
            () => require("./StudentLiveSatisfactionScreen").StudentLiveSatisfactionScreen,
            "StudentLiveSatisfactionScreen"
        )
    ),
    "live-quiz": livesInLive(
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        loadedOnRender(() => require("./StudentLiveQuizScreen").StudentLiveQuizScreen, "StudentLiveQuizScreen")
    ),
}
